import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import AdminLogin from './components/admin/AdminLogin';
import AuthCallback from './components/admin/AuthCallback';
import Storefront from './shop/Storefront';
import AdminShell from './shop/AdminShell';

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return <Routes><Route path="/admin" element={<AdminLogin />} /><Route path="/admin/dashboard/*" element={<AdminShell />} /><Route path="/*" element={<Storefront />} /></Routes>;
}
export default function App() {
  return <BrowserRouter><AppRouter /><Toaster position="top-center" toastOptions={{ style: { background: '#1C2033', color: '#F7F2EC', border: '1px solid #3a3f54', fontFamily: 'Jost, sans-serif' } }} /></BrowserRouter>;
}